import Button from 'components/field/Button';
import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import * as S from './styled/EmptyChart.styled';

const EmptyChart = ({ title, subtitle, buttonLabel, buttonAction, imageUrl, dashedBackground = false }) => (
	<S.EmprtyChartContainer dashedBackground={dashedBackground}>
		<Image
			url={imageUrl || 'https://storage.googleapis.com/tryoto-public/public/assets/images/emptyChart.svg'}
			alt="empty chart"
			height="12rem"
			width="12rem"
			className="my-4"
		/>
		{title && (
			<Typography variant="p2" className="my-4 text-center" fontWeight="700" noWrap>
				{title}
			</Typography>
		)}
		{subtitle && (
			<Typography variant="p3" className="text-center" color="var(--content-3)" noWrap>
				{subtitle}
			</Typography>
		)}
		{buttonLabel && buttonAction && (
			<Button label={buttonLabel} variant="blue" className="mt-4" onClick={buttonAction} />
		)}
	</S.EmprtyChartContainer>
);

export default EmptyChart;

export const defaultEmptyChartFields = {
	title: 'noDataTitle',
	subtitle: 'noDataSubtitle'
};
